var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showSlot)?_vm._t("default"):_c('no-internet-connection')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }